module.exports = __webpack_public_path__ + "e89ba7e2947e903b7538050f2e04795a.svg";